/* eslint-disable react/prop-types */
/* eslint-disable react/no-find-dom-node */
import React from 'react';
import { findDOMNode } from 'react-dom';
import Input from '@tencent/dui/lib/components/Input';

import Style from '../index.less';
import { browser } from '@src/slide/infrastructure/module/independent/agent/common';

interface IProps {
    itemPlaceholder?: string;
    inputTextInfo?: string;
    isWarning?: boolean;
    itemName: string;
    handleBlur?(): void;
    handleInputChange(value: string): void;
}

export default class LinkMenuItem extends React.Component<IProps> {
    private inputRef: any;

    public constructor(props, context) {
        super(props, context);
        this.inputRef = React.createRef();
    }

    public componentDidMount() {
        if (browser.isSafari) {
            const inputDom = findDOMNode(this.inputRef.current) as (HTMLElement | null);
            inputDom?.classList.add('safari-input');
        }
    }

    public handleChange = (value) => {
        this.props.handleInputChange(value);
    };

    public handleBlur = () => {
        if (this.props.handleBlur) {
            this.props.handleBlur();
        }
    };

    public focusInput = () => {
        this.inputRef?.current.focus();
    };

    public render() {
        const widthStyle = {
            width: '284px',
            height: '32px',
        };
        const inputStyle: React.CSSProperties = {
            opacity: 0.8,
            fontFamily: 'PingFangSC',
            borderRadius: 4,
            borderColor: this.props.isWarning ? '#ff7272' : undefined,
            height: '32px',
        };
        return (
            <div className={Style['link-menu-item']}>
                <label className={Style['link-menu-item-label']}>{this.props.itemName}</label>
                <Input
                    className={Style['link-menu-item-input']}
                    placeholder={this.props.itemPlaceholder}
                    style={widthStyle}
                    inputStyle={inputStyle}
                    value={this.props.inputTextInfo}
                    onChange={this.handleChange}
                    onBlur={this.handleBlur}
                    inputRef={this.inputRef}
                />
            </div>
        );
    }
}
